/**
 * Generated by orval v7.17.2 🍺
 * Do not edit manually.
 * Samlla
 * Samlla Backend API
 * OpenAPI spec version: 0.1.0
 */
import { createMutation, createQuery } from '@tanstack/svelte-query';
import type {
	CreateMutationOptions,
	CreateMutationResult,
	CreateQueryOptions,
	CreateQueryResult,
	DataTag,
	MutationFunction,
	QueryClient,
	QueryFunction,
	QueryKey
} from '@tanstack/svelte-query';

import type {
	AiQuickAddConsentGrant,
	AiQuickAddConsentWithdraw,
	HTTPValidationError,
	HealthDataConsentGrant,
	HealthDataConsentWithdraw,
	OnboardingCompleteRequest,
	UserRead,
	UserUpdate
} from '.././schemas';

import { customInstance } from '../../orval/mutator';

type SecondParameter<T extends (...args: never) => unknown> = Parameters<T>[1];

/**
 * Get current authenticated user information.
 * @summary Get Current User Info
 */
export const getCurrentUserInfoApiUsersMeGet = (
	options?: SecondParameter<typeof customInstance>,
	signal?: AbortSignal
) => {
	return customInstance<UserRead>({ url: `/api/users/me`, method: 'GET', signal }, options);
};

export const getGetCurrentUserInfoApiUsersMeGetQueryKey = () => {
	return [`/api/users/me`] as const;
};

export const getGetCurrentUserInfoApiUsersMeGetQueryOptions = <
	TData = Awaited<ReturnType<typeof getCurrentUserInfoApiUsersMeGet>>,
	TError = unknown
>(options?: {
	query?: Partial<
		CreateQueryOptions<Awaited<ReturnType<typeof getCurrentUserInfoApiUsersMeGet>>, TError, TData>
	>;
	request?: SecondParameter<typeof customInstance>;
}) => {
	const { query: queryOptions, request: requestOptions } = options ?? {};

	const queryKey = queryOptions?.queryKey ?? getGetCurrentUserInfoApiUsersMeGetQueryKey();

	const queryFn: QueryFunction<Awaited<ReturnType<typeof getCurrentUserInfoApiUsersMeGet>>> = ({
		signal
	}) => getCurrentUserInfoApiUsersMeGet(requestOptions, signal);

	return { queryKey, queryFn, ...queryOptions } as CreateQueryOptions<
		Awaited<ReturnType<typeof getCurrentUserInfoApiUsersMeGet>>,
		TError,
		TData
	> & { queryKey: DataTag<QueryKey, TData, TError> };
};

export type GetCurrentUserInfoApiUsersMeGetQueryResult = NonNullable<
	Awaited<ReturnType<typeof getCurrentUserInfoApiUsersMeGet>>
>;
export type GetCurrentUserInfoApiUsersMeGetQueryError = unknown;

/**
 * @summary Get Current User Info
 */

export function createGetCurrentUserInfoApiUsersMeGet<
	TData = Awaited<ReturnType<typeof getCurrentUserInfoApiUsersMeGet>>,
	TError = unknown
>(
	options?: {
		query?: Partial<
			CreateQueryOptions<Awaited<ReturnType<typeof getCurrentUserInfoApiUsersMeGet>>, TError, TData>
		>;
		request?: SecondParameter<typeof customInstance>;
	},
	queryClient?: QueryClient
): CreateQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> } {
	const queryOptions = getGetCurrentUserInfoApiUsersMeGetQueryOptions(options);

	const query = createQuery(() => ({ ...queryOptions, queryClient })) as CreateQueryResult<
		TData,
		TError
	> & { queryKey: DataTag<QueryKey, TData, TError> };

	query.queryKey = queryOptions.queryKey;

	return query;
}

/**
 * Update current authenticated user information.
 * @summary Update Current User
 */
export const updateCurrentUserApiUsersMePatch = (
	userUpdate: UserUpdate,
	options?: SecondParameter<typeof customInstance>
) => {
	return customInstance<UserRead>(
		{
			url: `/api/users/me`,
			method: 'PATCH',
			headers: { 'Content-Type': 'application/json' },
			data: userUpdate
		},
		options
	);
};

export const getUpdateCurrentUserApiUsersMePatchMutationOptions = <
	TError = HTTPValidationError,
	TContext = unknown
>(options?: {
	mutation?: CreateMutationOptions<
		Awaited<ReturnType<typeof updateCurrentUserApiUsersMePatch>>,
		TError,
		{ data: UserUpdate },
		TContext
	>;
	request?: SecondParameter<typeof customInstance>;
}): CreateMutationOptions<
	Awaited<ReturnType<typeof updateCurrentUserApiUsersMePatch>>,
	TError,
	{ data: UserUpdate },
	TContext
> => {
	const mutationKey = ['updateCurrentUserApiUsersMePatch'];
	const { mutation: mutationOptions, request: requestOptions } = options
		? options.mutation && 'mutationKey' in options.mutation && options.mutation.mutationKey
			? options
			: { ...options, mutation: { ...options.mutation, mutationKey } }
		: { mutation: { mutationKey }, request: undefined };

	const mutationFn: MutationFunction<
		Awaited<ReturnType<typeof updateCurrentUserApiUsersMePatch>>,
		{ data: UserUpdate }
	> = (props) => {
		const { data } = props ?? {};

		return updateCurrentUserApiUsersMePatch(data, requestOptions);
	};

	return { mutationFn, ...mutationOptions };
};

export type UpdateCurrentUserApiUsersMePatchMutationResult = NonNullable<
	Awaited<ReturnType<typeof updateCurrentUserApiUsersMePatch>>
>;
export type UpdateCurrentUserApiUsersMePatchMutationBody = UserUpdate;
export type UpdateCurrentUserApiUsersMePatchMutationError = HTTPValidationError;

/**
 * @summary Update Current User
 */
export const createUpdateCurrentUserApiUsersMePatch = <
	TError = HTTPValidationError,
	TContext = unknown
>(
	options?: {
		mutation?: CreateMutationOptions<
			Awaited<ReturnType<typeof updateCurrentUserApiUsersMePatch>>,
			TError,
			{ data: UserUpdate },
			TContext
		>;
		request?: SecondParameter<typeof customInstance>;
	},
	queryClient?: QueryClient
): CreateMutationResult<
	Awaited<ReturnType<typeof updateCurrentUserApiUsersMePatch>>,
	TError,
	{ data: UserUpdate },
	TContext
> => {
	const mutationOptions = getUpdateCurrentUserApiUsersMePatchMutationOptions(options);

	return createMutation(() => ({ ...mutationOptions, queryClient }));
};
/**
 * Record the first time a user enters onboarding.
 * @summary Start Onboarding
 */
export const startOnboardingApiUsersMeOnboardingStartPost = (
	options?: SecondParameter<typeof customInstance>,
	signal?: AbortSignal
) => {
	return customInstance<UserRead>(
		{ url: `/api/users/me/onboarding/start`, method: 'POST', signal },
		options
	);
};

export const getStartOnboardingApiUsersMeOnboardingStartPostMutationOptions = <
	TError = unknown,
	TContext = unknown
>(options?: {
	mutation?: CreateMutationOptions<
		Awaited<ReturnType<typeof startOnboardingApiUsersMeOnboardingStartPost>>,
		TError,
		void,
		TContext
	>;
	request?: SecondParameter<typeof customInstance>;
}): CreateMutationOptions<
	Awaited<ReturnType<typeof startOnboardingApiUsersMeOnboardingStartPost>>,
	TError,
	void,
	TContext
> => {
	const mutationKey = ['startOnboardingApiUsersMeOnboardingStartPost'];
	const { mutation: mutationOptions, request: requestOptions } = options
		? options.mutation && 'mutationKey' in options.mutation && options.mutation.mutationKey
			? options
			: { ...options, mutation: { ...options.mutation, mutationKey } }
		: { mutation: { mutationKey }, request: undefined };

	const mutationFn: MutationFunction<
		Awaited<ReturnType<typeof startOnboardingApiUsersMeOnboardingStartPost>>,
		void
	> = () => {
		return startOnboardingApiUsersMeOnboardingStartPost(requestOptions);
	};

	return { mutationFn, ...mutationOptions };
};

export type StartOnboardingApiUsersMeOnboardingStartPostMutationResult = NonNullable<
	Awaited<ReturnType<typeof startOnboardingApiUsersMeOnboardingStartPost>>
>;

export type StartOnboardingApiUsersMeOnboardingStartPostMutationError = unknown;

/**
 * @summary Start Onboarding
 */
export const createStartOnboardingApiUsersMeOnboardingStartPost = <
	TError = unknown,
	TContext = unknown
>(
	options?: {
		mutation?: CreateMutationOptions<
			Awaited<ReturnType<typeof startOnboardingApiUsersMeOnboardingStartPost>>,
			TError,
			void,
			TContext
		>;
		request?: SecondParameter<typeof customInstance>;
	},
	queryClient?: QueryClient
): CreateMutationResult<
	Awaited<ReturnType<typeof startOnboardingApiUsersMeOnboardingStartPost>>,
	TError,
	void,
	TContext
> => {
	const mutationOptions = getStartOnboardingApiUsersMeOnboardingStartPostMutationOptions(options);

	return createMutation(() => ({ ...mutationOptions, queryClient }));
};
/**
 * Complete onboarding once and retain the first completion method.
 * @summary Complete Onboarding
 */
export const completeOnboardingApiUsersMeOnboardingCompletePost = (
	onboardingCompleteRequest: OnboardingCompleteRequest,
	options?: SecondParameter<typeof customInstance>,
	signal?: AbortSignal
) => {
	return customInstance<UserRead>(
		{
			url: `/api/users/me/onboarding/complete`,
			method: 'POST',
			headers: { 'Content-Type': 'application/json' },
			data: onboardingCompleteRequest,
			signal
		},
		options
	);
};

export const getCompleteOnboardingApiUsersMeOnboardingCompletePostMutationOptions = <
	TError = HTTPValidationError,
	TContext = unknown
>(options?: {
	mutation?: CreateMutationOptions<
		Awaited<ReturnType<typeof completeOnboardingApiUsersMeOnboardingCompletePost>>,
		TError,
		{ data: OnboardingCompleteRequest },
		TContext
	>;
	request?: SecondParameter<typeof customInstance>;
}): CreateMutationOptions<
	Awaited<ReturnType<typeof completeOnboardingApiUsersMeOnboardingCompletePost>>,
	TError,
	{ data: OnboardingCompleteRequest },
	TContext
> => {
	const mutationKey = ['completeOnboardingApiUsersMeOnboardingCompletePost'];
	const { mutation: mutationOptions, request: requestOptions } = options
		? options.mutation && 'mutationKey' in options.mutation && options.mutation.mutationKey
			? options
			: { ...options, mutation: { ...options.mutation, mutationKey } }
		: { mutation: { mutationKey }, request: undefined };

	const mutationFn: MutationFunction<
		Awaited<ReturnType<typeof completeOnboardingApiUsersMeOnboardingCompletePost>>,
		{ data: OnboardingCompleteRequest }
	> = (props) => {
		const { data } = props ?? {};

		return completeOnboardingApiUsersMeOnboardingCompletePost(data, requestOptions);
	};

	return { mutationFn, ...mutationOptions };
};

export type CompleteOnboardingApiUsersMeOnboardingCompletePostMutationResult = NonNullable<
	Awaited<ReturnType<typeof completeOnboardingApiUsersMeOnboardingCompletePost>>
>;
export type CompleteOnboardingApiUsersMeOnboardingCompletePostMutationBody =
	OnboardingCompleteRequest;
export type CompleteOnboardingApiUsersMeOnboardingCompletePostMutationError = HTTPValidationError;

/**
 * @summary Complete Onboarding
 */
export const createCompleteOnboardingApiUsersMeOnboardingCompletePost = <
	TError = HTTPValidationError,
	TContext = unknown
>(
	options?: {
		mutation?: CreateMutationOptions<
			Awaited<ReturnType<typeof completeOnboardingApiUsersMeOnboardingCompletePost>>,
			TError,
			{ data: OnboardingCompleteRequest },
			TContext
		>;
		request?: SecondParameter<typeof customInstance>;
	},
	queryClient?: QueryClient
): CreateMutationResult<
	Awaited<ReturnType<typeof completeOnboardingApiUsersMeOnboardingCompletePost>>,
	TError,
	{ data: OnboardingCompleteRequest },
	TContext
> => {
	const mutationOptions =
		getCompleteOnboardingApiUsersMeOnboardingCompletePostMutationOptions(options);

	return createMutation(() => ({ ...mutationOptions, queryClient }));
};
/**
 * Remember that the one-time baseline-ready message was seen.
 * @summary Acknowledge Baseline Nudge
 */
export const acknowledgeBaselineNudgeApiUsersMeBaselineNudgeSeenPost = (
	options?: SecondParameter<typeof customInstance>,
	signal?: AbortSignal
) => {
	return customInstance<UserRead>(
		{ url: `/api/users/me/baseline-nudge/seen`, method: 'POST', signal },
		options
	);
};

export const getAcknowledgeBaselineNudgeApiUsersMeBaselineNudgeSeenPostMutationOptions = <
	TError = unknown,
	TContext = unknown
>(options?: {
	mutation?: CreateMutationOptions<
		Awaited<ReturnType<typeof acknowledgeBaselineNudgeApiUsersMeBaselineNudgeSeenPost>>,
		TError,
		void,
		TContext
	>;
	request?: SecondParameter<typeof customInstance>;
}): CreateMutationOptions<
	Awaited<ReturnType<typeof acknowledgeBaselineNudgeApiUsersMeBaselineNudgeSeenPost>>,
	TError,
	void,
	TContext
> => {
	const mutationKey = ['acknowledgeBaselineNudgeApiUsersMeBaselineNudgeSeenPost'];
	const { mutation: mutationOptions, request: requestOptions } = options
		? options.mutation && 'mutationKey' in options.mutation && options.mutation.mutationKey
			? options
			: { ...options, mutation: { ...options.mutation, mutationKey } }
		: { mutation: { mutationKey }, request: undefined };

	const mutationFn: MutationFunction<
		Awaited<ReturnType<typeof acknowledgeBaselineNudgeApiUsersMeBaselineNudgeSeenPost>>,
		void
	> = () => {
		return acknowledgeBaselineNudgeApiUsersMeBaselineNudgeSeenPost(requestOptions);
	};

	return { mutationFn, ...mutationOptions };
};

export type AcknowledgeBaselineNudgeApiUsersMeBaselineNudgeSeenPostMutationResult = NonNullable<
	Awaited<ReturnType<typeof acknowledgeBaselineNudgeApiUsersMeBaselineNudgeSeenPost>>
>;

export type AcknowledgeBaselineNudgeApiUsersMeBaselineNudgeSeenPostMutationError = unknown;

/**
 * @summary Acknowledge Baseline Nudge
 */
export const createAcknowledgeBaselineNudgeApiUsersMeBaselineNudgeSeenPost = <
	TError = unknown,
	TContext = unknown
>(
	options?: {
		mutation?: CreateMutationOptions<
			Awaited<ReturnType<typeof acknowledgeBaselineNudgeApiUsersMeBaselineNudgeSeenPost>>,
			TError,
			void,
			TContext
		>;
		request?: SecondParameter<typeof customInstance>;
	},
	queryClient?: QueryClient
): CreateMutationResult<
	Awaited<ReturnType<typeof acknowledgeBaselineNudgeApiUsersMeBaselineNudgeSeenPost>>,
	TError,
	void,
	TContext
> => {
	const mutationOptions =
		getAcknowledgeBaselineNudgeApiUsersMeBaselineNudgeSeenPostMutationOptions(options);

	return createMutation(() => ({ ...mutationOptions, queryClient }));
};
/**
 * Record explicit GDPR art. 9(2)(a) consent for the current version (SML-140).
 * @summary Grant Health Data Consent
 */
export const grantHealthDataConsentApiUsersMeHealthDataConsentPost = (
	healthDataConsentGrant: HealthDataConsentGrant,
	options?: SecondParameter<typeof customInstance>,
	signal?: AbortSignal
) => {
	return customInstance<UserRead>(
		{
			url: `/api/users/me/health-data-consent`,
			method: 'POST',
			headers: { 'Content-Type': 'application/json' },
			data: healthDataConsentGrant,
			signal
		},
		options
	);
};

export const getGrantHealthDataConsentApiUsersMeHealthDataConsentPostMutationOptions = <
	TError = HTTPValidationError,
	TContext = unknown
>(options?: {
	mutation?: CreateMutationOptions<
		Awaited<ReturnType<typeof grantHealthDataConsentApiUsersMeHealthDataConsentPost>>,
		TError,
		{ data: HealthDataConsentGrant },
		TContext
	>;
	request?: SecondParameter<typeof customInstance>;
}): CreateMutationOptions<
	Awaited<ReturnType<typeof grantHealthDataConsentApiUsersMeHealthDataConsentPost>>,
	TError,
	{ data: HealthDataConsentGrant },
	TContext
> => {
	const mutationKey = ['grantHealthDataConsentApiUsersMeHealthDataConsentPost'];
	const { mutation: mutationOptions, request: requestOptions } = options
		? options.mutation && 'mutationKey' in options.mutation && options.mutation.mutationKey
			? options
			: { ...options, mutation: { ...options.mutation, mutationKey } }
		: { mutation: { mutationKey }, request: undefined };

	const mutationFn: MutationFunction<
		Awaited<ReturnType<typeof grantHealthDataConsentApiUsersMeHealthDataConsentPost>>,
		{ data: HealthDataConsentGrant }
	> = (props) => {
		const { data } = props ?? {};

		return grantHealthDataConsentApiUsersMeHealthDataConsentPost(data, requestOptions);
	};

	return { mutationFn, ...mutationOptions };
};

export type GrantHealthDataConsentApiUsersMeHealthDataConsentPostMutationResult = NonNullable<
	Awaited<ReturnType<typeof grantHealthDataConsentApiUsersMeHealthDataConsentPost>>
>;
export type GrantHealthDataConsentApiUsersMeHealthDataConsentPostMutationBody =
	HealthDataConsentGrant;
export type GrantHealthDataConsentApiUsersMeHealthDataConsentPostMutationError =
	HTTPValidationError;

/**
 * @summary Grant Health Data Consent
 */
export const createGrantHealthDataConsentApiUsersMeHealthDataConsentPost = <
	TError = HTTPValidationError,
	TContext = unknown
>(
	options?: {
		mutation?: CreateMutationOptions<
			Awaited<ReturnType<typeof grantHealthDataConsentApiUsersMeHealthDataConsentPost>>,
			TError,
			{ data: HealthDataConsentGrant },
			TContext
		>;
		request?: SecondParameter<typeof customInstance>;
	},
	queryClient?: QueryClient
): CreateMutationResult<
	Awaited<ReturnType<typeof grantHealthDataConsentApiUsersMeHealthDataConsentPost>>,
	TError,
	{ data: HealthDataConsentGrant },
	TContext
> => {
	const mutationOptions =
		getGrantHealthDataConsentApiUsersMeHealthDataConsentPostMutationOptions(options);

	return createMutation(() => ({ ...mutationOptions, queryClient }));
};
/**
 * Withdraw health-data consent; stored data is kept, not deleted (SML-140).
 * @summary Withdraw Health Data Consent
 */
export const withdrawHealthDataConsentApiUsersMeHealthDataConsentWithdrawPost = (
	healthDataConsentWithdraw: HealthDataConsentWithdraw,
	options?: SecondParameter<typeof customInstance>,
	signal?: AbortSignal
) => {
	return customInstance<UserRead>(
		{
			url: `/api/users/me/health-data-consent/withdraw`,
			method: 'POST',
			headers: { 'Content-Type': 'application/json' },
			data: healthDataConsentWithdraw,
			signal
		},
		options
	);
};

export const getWithdrawHealthDataConsentApiUsersMeHealthDataConsentWithdrawPostMutationOptions = <
	TError = HTTPValidationError,
	TContext = unknown
>(options?: {
	mutation?: CreateMutationOptions<
		Awaited<ReturnType<typeof withdrawHealthDataConsentApiUsersMeHealthDataConsentWithdrawPost>>,
		TError,
		{ data: HealthDataConsentWithdraw },
		TContext
	>;
	request?: SecondParameter<typeof customInstance>;
}): CreateMutationOptions<
	Awaited<ReturnType<typeof withdrawHealthDataConsentApiUsersMeHealthDataConsentWithdrawPost>>,
	TError,
	{ data: HealthDataConsentWithdraw },
	TContext
> => {
	const mutationKey = ['withdrawHealthDataConsentApiUsersMeHealthDataConsentWithdrawPost'];
	const { mutation: mutationOptions, request: requestOptions } = options
		? options.mutation && 'mutationKey' in options.mutation && options.mutation.mutationKey
			? options
			: { ...options, mutation: { ...options.mutation, mutationKey } }
		: { mutation: { mutationKey }, request: undefined };

	const mutationFn: MutationFunction<
		Awaited<ReturnType<typeof withdrawHealthDataConsentApiUsersMeHealthDataConsentWithdrawPost>>,
		{ data: HealthDataConsentWithdraw }
	> = (props) => {
		const { data } = props ?? {};

		return withdrawHealthDataConsentApiUsersMeHealthDataConsentWithdrawPost(data, requestOptions);
	};

	return { mutationFn, ...mutationOptions };
};

export type WithdrawHealthDataConsentApiUsersMeHealthDataConsentWithdrawPostMutationResult =
	NonNullable<
		Awaited<ReturnType<typeof withdrawHealthDataConsentApiUsersMeHealthDataConsentWithdrawPost>>
	>;
export type WithdrawHealthDataConsentApiUsersMeHealthDataConsentWithdrawPostMutationBody =
	HealthDataConsentWithdraw;
export type WithdrawHealthDataConsentApiUsersMeHealthDataConsentWithdrawPostMutationError =
	HTTPValidationError;

/**
 * @summary Withdraw Health Data Consent
 */
export const createWithdrawHealthDataConsentApiUsersMeHealthDataConsentWithdrawPost = <
	TError = HTTPValidationError,
	TContext = unknown
>(
	options?: {
		mutation?: CreateMutationOptions<
			Awaited<ReturnType<typeof withdrawHealthDataConsentApiUsersMeHealthDataConsentWithdrawPost>>,
			TError,
			{ data: HealthDataConsentWithdraw },
			TContext
		>;
		request?: SecondParameter<typeof customInstance>;
	},
	queryClient?: QueryClient
): CreateMutationResult<
	Awaited<ReturnType<typeof withdrawHealthDataConsentApiUsersMeHealthDataConsentWithdrawPost>>,
	TError,
	{ data: HealthDataConsentWithdraw },
	TContext
> => {
	const mutationOptions =
		getWithdrawHealthDataConsentApiUsersMeHealthDataConsentWithdrawPostMutationOptions(options);

	return createMutation(() => ({ ...mutationOptions, queryClient }));
};
/**
 * Record the separate consent for OpenAI-backed Quick Add.
 * @summary Grant Ai Quick Add Consent
 */
export const grantAiQuickAddConsentApiUsersMeAiQuickAddConsentPost = (
	aiQuickAddConsentGrant: AiQuickAddConsentGrant,
	options?: SecondParameter<typeof customInstance>,
	signal?: AbortSignal
) => {
	return customInstance<UserRead>(
		{
			url: `/api/users/me/ai-quick-add-consent`,
			method: 'POST',
			headers: { 'Content-Type': 'application/json' },
			data: aiQuickAddConsentGrant,
			signal
		},
		options
	);
};

export const getGrantAiQuickAddConsentApiUsersMeAiQuickAddConsentPostMutationOptions = <
	TError = HTTPValidationError,
	TContext = unknown
>(options?: {
	mutation?: CreateMutationOptions<
		Awaited<ReturnType<typeof grantAiQuickAddConsentApiUsersMeAiQuickAddConsentPost>>,
		TError,
		{ data: AiQuickAddConsentGrant },
		TContext
	>;
	request?: SecondParameter<typeof customInstance>;
}): CreateMutationOptions<
	Awaited<ReturnType<typeof grantAiQuickAddConsentApiUsersMeAiQuickAddConsentPost>>,
	TError,
	{ data: AiQuickAddConsentGrant },
	TContext
> => {
	const mutationKey = ['grantAiQuickAddConsentApiUsersMeAiQuickAddConsentPost'];
	const { mutation: mutationOptions, request: requestOptions } = options
		? options.mutation && 'mutationKey' in options.mutation && options.mutation.mutationKey
			? options
			: { ...options, mutation: { ...options.mutation, mutationKey } }
		: { mutation: { mutationKey }, request: undefined };

	const mutationFn: MutationFunction<
		Awaited<ReturnType<typeof grantAiQuickAddConsentApiUsersMeAiQuickAddConsentPost>>,
		{ data: AiQuickAddConsentGrant }
	> = (props) => {
		const { data } = props ?? {};

		return grantAiQuickAddConsentApiUsersMeAiQuickAddConsentPost(data, requestOptions);
	};

	return { mutationFn, ...mutationOptions };
};

export type GrantAiQuickAddConsentApiUsersMeAiQuickAddConsentPostMutationResult = NonNullable<
	Awaited<ReturnType<typeof grantAiQuickAddConsentApiUsersMeAiQuickAddConsentPost>>
>;
export type GrantAiQuickAddConsentApiUsersMeAiQuickAddConsentPostMutationBody =
	AiQuickAddConsentGrant;
export type GrantAiQuickAddConsentApiUsersMeAiQuickAddConsentPostMutationError =
	HTTPValidationError;

/**
 * @summary Grant Ai Quick Add Consent
 */
export const createGrantAiQuickAddConsentApiUsersMeAiQuickAddConsentPost = <
	TError = HTTPValidationError,
	TContext = unknown
>(
	options?: {
		mutation?: CreateMutationOptions<
			Awaited<ReturnType<typeof grantAiQuickAddConsentApiUsersMeAiQuickAddConsentPost>>,
			TError,
			{ data: AiQuickAddConsentGrant },
			TContext
		>;
		request?: SecondParameter<typeof customInstance>;
	},
	queryClient?: QueryClient
): CreateMutationResult<
	Awaited<ReturnType<typeof grantAiQuickAddConsentApiUsersMeAiQuickAddConsentPost>>,
	TError,
	{ data: AiQuickAddConsentGrant },
	TContext
> => {
	const mutationOptions =
		getGrantAiQuickAddConsentApiUsersMeAiQuickAddConsentPostMutationOptions(options);

	return createMutation(() => ({ ...mutationOptions, queryClient }));
};
/**
 * Withdraw Quick Add consent without deleting journal entries.
 * @summary Withdraw Ai Quick Add Consent
 */
export const withdrawAiQuickAddConsentApiUsersMeAiQuickAddConsentWithdrawPost = (
	aiQuickAddConsentWithdraw: AiQuickAddConsentWithdraw,
	options?: SecondParameter<typeof customInstance>,
	signal?: AbortSignal
) => {
	return customInstance<UserRead>(
		{
			url: `/api/users/me/ai-quick-add-consent/withdraw`,
			method: 'POST',
			headers: { 'Content-Type': 'application/json' },
			data: aiQuickAddConsentWithdraw,
			signal
		},
		options
	);
};

export const getWithdrawAiQuickAddConsentApiUsersMeAiQuickAddConsentWithdrawPostMutationOptions = <
	TError = HTTPValidationError,
	TContext = unknown
>(options?: {
	mutation?: CreateMutationOptions<
		Awaited<ReturnType<typeof withdrawAiQuickAddConsentApiUsersMeAiQuickAddConsentWithdrawPost>>,
		TError,
		{ data: AiQuickAddConsentWithdraw },
		TContext
	>;
	request?: SecondParameter<typeof customInstance>;
}): CreateMutationOptions<
	Awaited<ReturnType<typeof withdrawAiQuickAddConsentApiUsersMeAiQuickAddConsentWithdrawPost>>,
	TError,
	{ data: AiQuickAddConsentWithdraw },
	TContext
> => {
	const mutationKey = ['withdrawAiQuickAddConsentApiUsersMeAiQuickAddConsentWithdrawPost'];
	const { mutation: mutationOptions, request: requestOptions } = options
		? options.mutation && 'mutationKey' in options.mutation && options.mutation.mutationKey
			? options
			: { ...options, mutation: { ...options.mutation, mutationKey } }
		: { mutation: { mutationKey }, request: undefined };

	const mutationFn: MutationFunction<
		Awaited<ReturnType<typeof withdrawAiQuickAddConsentApiUsersMeAiQuickAddConsentWithdrawPost>>,
		{ data: AiQuickAddConsentWithdraw }
	> = (props) => {
		const { data } = props ?? {};

		return withdrawAiQuickAddConsentApiUsersMeAiQuickAddConsentWithdrawPost(data, requestOptions);
	};

	return { mutationFn, ...mutationOptions };
};

export type WithdrawAiQuickAddConsentApiUsersMeAiQuickAddConsentWithdrawPostMutationResult =
	NonNullable<
		Awaited<ReturnType<typeof withdrawAiQuickAddConsentApiUsersMeAiQuickAddConsentWithdrawPost>>
	>;
export type WithdrawAiQuickAddConsentApiUsersMeAiQuickAddConsentWithdrawPostMutationBody =
	AiQuickAddConsentWithdraw;
export type WithdrawAiQuickAddConsentApiUsersMeAiQuickAddConsentWithdrawPostMutationError =
	HTTPValidationError;

/**
 * @summary Withdraw Ai Quick Add Consent
 */
export const createWithdrawAiQuickAddConsentApiUsersMeAiQuickAddConsentWithdrawPost = <
	TError = HTTPValidationError,
	TContext = unknown
>(
	options?: {
		mutation?: CreateMutationOptions<
			Awaited<ReturnType<typeof withdrawAiQuickAddConsentApiUsersMeAiQuickAddConsentWithdrawPost>>,
			TError,
			{ data: AiQuickAddConsentWithdraw },
			TContext
		>;
		request?: SecondParameter<typeof customInstance>;
	},
	queryClient?: QueryClient
): CreateMutationResult<
	Awaited<ReturnType<typeof withdrawAiQuickAddConsentApiUsersMeAiQuickAddConsentWithdrawPost>>,
	TError,
	{ data: AiQuickAddConsentWithdraw },
	TContext
> => {
	const mutationOptions =
		getWithdrawAiQuickAddConsentApiUsersMeAiQuickAddConsentWithdrawPostMutationOptions(options);

	return createMutation(() => ({ ...mutationOptions, queryClient }));
};
